import React, { useEffect, useState } from "react";
import MasterTable from "../common/MasterTable";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import Loader from "../Loader/Loader";
import { format, isValid, parse } from "date-fns";
import { useDispatch } from "react-redux";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";
import BagBookingFilterModal from "./BagBookingFilterModal";
import AddCourierBagModal from "./AddCourierBagModal";
import AddItemBagModal from "./AddItemBagModal";
import NotificationDetailsModal from "./NotificationDetailMoadl";
import SuccessModal from "../successModal/successModal";
import SelectToNotifyModal from "./SelectToNotify";
import FilterBar from "../common/FilterBar";
import { BAG_STATUS_OPTIONS } from "../common/filterOptions";

// Helper function to get date 7 days ago in YYYY-MM-DD format
const getLast7DaysDate = () => {
  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);

  const year = sevenDaysAgo.getFullYear();
  const month = String(sevenDaysAgo.getMonth() + 1).padStart(2, "0");
  const day = String(sevenDaysAgo.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Helper function to get today's date in YYYY-MM-DD format
const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const defaultFilterData = {
  bagNo: "",
  fromDate: getLast7DaysDate(),
  toDate: getTodayDate(),
  status: "",
  search: "",
};

const orderHeader = [
  "Products",
  "Status",
  "LMBP Id",
  "LMBP Name",
  "Consignee Name",
  "Mobile No",
  "Phone No",
  "Email Id",
  "Address Line 1",
  "Address Line 2",
  "Address Type",
  "Pincode",
  "City",
  "State",
  "Country",
  "Invoice Number",
  "Payment Mode",
  "Express Type",
  "Order Amount (₹)",
  "COD Amount (₹)",
  "Shipment Weight",
  "Shipment Length",
  "Shipment Width",
  "Shipment Height",
  "Pick Address ID",
  "Return Address ID",
  "Seller ID",
  "E-Way Bill Number",
  "Route Code",
  "Carrier",
  "Created Date",
  "Response",
  "Waybill",
];

const BookingMaster = () => {
  const [pageSize, setPageSize] = useState(10);
  const [noData, setNoData] = useState(false);
  const [noOrderData, setNoOrderData] = useState(false);
  const [editData, setEditData] = useState({});
  const [customerData, setCustomerData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageDetailsModal, setPageDetailsModal] = useState(null);
  const loggedInUserName = sessionStorage.getItem("username");
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [columnData, setColumnData] = useState("");
  const [orderData, setOrderData] = useState([]);
  const [autoSelectAll, setAutoSelectAll] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);

  const dispatch = useDispatch();

  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
  const [isAddItemModalOpen, setIsAddItemModalOpen] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openToNotifyModal, setOpenToNotifyModal] = useState(false);
  const [franchiseData, setFranchiseData] = useState("");

  const openModalCreate = () => {
    setIsModalOpenCreate(true);
  };

  const closeModalCreate = () => {
    setIsModalOpenCreate(false);
  };

  const openAddItemModal = () => {
    setIsAddItemModalOpen(true);
  };

  const closeAddItemModal = () => {
    setIsAddItemModalOpen(false);
  };

  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    fetchBagData(1, filterData);
  }, []);

  // fetch order data for add items modal
  const fetchOrderData = async (currentPage, flag, row) => {
    setLoadingModal(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        ...(flag === "addItem"
          ? { excludeBaggedOrders: true }
          : { itemsIncluded: row?.itemsIncluded || [] }),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_ORDER_MASTER_DATA}?pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody,
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetailsModal(response?.data?.pageDetails);
        const modifiedData = modifyStructureForModal(response?.data?.data);
        setOrderData(modifiedData);
        setNoOrderData(modifiedData?.length === 0);
      } else if (response?.data?.respCode === "01") {
        setOrderData([]);
        setNoOrderData(true);
      } else {
        setNoOrderData(true);
        setOrderData([]);
        CustomAlert({
          title: "Failed",
          text: response?.data?.message || "Failed to fetch data",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setNoOrderData(true);
      setOrderData([]);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoadingModal(false);
    }
  };

  const modifyStructureForModal = (response) => {
    const modified = response?.map((user, index) => {
      const formattedCreDate = user?.createdDate
        ? parse(user.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;
      return {
        ...user,
        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : "",
      };
    });
    return modified;
  };

  // fetch bag data
  const fetchBagData = async (
    currentPage,
    filters = defaultFilterData,
    size = pageSize,
  ) => {
    setLoading(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        bagNo: filters.bagNo || "",
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
        status: filters.status || "",
        search: filters.search || "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_BAG_MASTER}?&pageSize=${size}&pageNo=${currentPage}`,
        requestBody,
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setLoading(false);
        setPageDetails(response?.data?.pageDetails);
        setFranchiseData(response?.data?.franchiseDetails);
        const modifiedData = modifyStructure(
          response?.data?.data,
          handleItemsIncludedClick,
        );
        setCustomerData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setLoading(false);
        setNoData(true);
        setCustomerData([]);
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response, handleItemsIncludedClick) => {
    return response?.map((user, index) => {
      let formattedCreDate = null;
      let formattedStrDate = null;

      if (user?.createdDate) {
        const parsed = parse(
          user.createdDate,
          "dd-MM-yyyy HH:mm:ss",
          new Date(),
        );
        if (isValid(parsed)) {
          formattedCreDate = parsed;
        } else {
          console.warn("Invalid createdDate:", user.createdDate);
        }
      }

      if (user?.startDateTime) {
        const parsed = parse(
          user.startDateTime,
          "dd-MM-yyyy HH:mm:ss",
          new Date(),
        );
        if (isValid(parsed)) {
          formattedStrDate = parsed;
        } else {
          console.warn("Invalid startDateTime:", user.startDateTime);
        }
      }

      const itemCount = user.itemsIncluded?.length || 0;

      const itemsIncludedIds = Array.isArray(user.itemsIncluded)
        ? user.itemsIncluded
        : []; // backend expects array

      return {
        ...user,

        itemsIncludedIds,

        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : "",

        startDateTime: formattedStrDate
          ? [
              format(formattedStrDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedStrDate, "HH:mm:ss"),
            ]
          : "",

        itemsIncluded: (
          <span
            className="text-blue-600 underline cursor-pointer"
            onClick={() => handleItemsIncludedClick(user)}
          >
            {itemCount > 0
              ? `${itemCount} Item${itemCount > 1 ? "s" : ""}`
              : "No Items"}
          </span>
        ),
      };
    });
  };

  const handleItemsIncludedClick = (row) => {
    setEditData(row); // set selected bag details
    setColumnData(row);
    setIsAddItemModalOpen(true);
    fetchOrderData(1, "ItemsIncluded", row);
    setAutoSelectAll(true);
  };

  const customerHeader = [
    "Bag No",
    "Created Date",
    "Created By",
    "Status",
    "Items Included",
    "Start date & Time",
  ];

  const customerHeaderToKeyMap = {
    "Bag No": "bagNo",
    "Created Date": "createdDate",
    "Created By": "createdBy",
    Status: "status",
    "Items Included": "itemsIncluded",
    "Start date & Time": "startDateTime",
  };

  const handleAuthorization = (data, actionType = "view") => {
    setModalAction(actionType);
    setColumnData(data);
    let custData = customerData.find((item) => item?.id === data?.id);
    if (custData) {
      setEditData(custData);
      setIsModalOpenCreate(true);
    }
  };

  const handleCustomer = (data, actionType = "view") => {
    setModalAction(actionType);
    setColumnData(data);
    if (actionType === "add") {
      setEditData({});
      openModalCreate(true);
    } else if (actionType === "addItem") {
      setAutoSelectAll(false);
      setEditData({});
      if (data?.status !== "SEALED") {
        fetchOrderData(1, "addItem");
        openAddItemModal();
      } else {
        CustomAlert({
          title: "Warning",
          text: "Cannot add items to a SEALED bag.",
          icon: "warning",
          confirmButtonText: "Okay",
        });
      }
    } else if (actionType === "model") {
      setEditData({});
      setOpenToNotifyModal(true);
    } else if (actionType === "seal") {
      setEditData({});
      handleBagSeal(data);
    } else if (actionType === "notification") {
      setNotificationModal(true);
    } else if (actionType === "unpack") {
      setEditData({});
      setOpenSuccessModal(true);
    } else if (actionType === "auth") {
      let custData = customerData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
        setIsModalOpenCreate(true);
      }
    } else {
      let custData = customerData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
        openModalCreate(true);
      }
    }
  };

  const handleBagSeal = async (data) => {
    try {
      const payload = {
        username: loggedInUserName,
        bagNo: data?.bagNo,
      };

      const response = await axiosPostApi(apiList.BAG_SEAL, payload);
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
          allowOutsideClick: false,
        });
        fetchBagData(currentPage);
      } else if (response?.status === 200 && !response?.data?.status) {
        CustomAlert({
          title: "Failed to Request",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      console.error("Error processing request:", error);
      CustomAlert({
        title: "Error",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
  };

  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <>
      <HeaderWithBreadcrumb title="Bag Master" breadcrumb="Master" />
      <FilterBar
        values={filterData}
        onChange={(next) => {
          setFilterData(next);
          setCurrentPage(1);
          fetchBagData(1, next, pageSize);
        }}
        search={{ key: "search", placeholder: "Search bag no., created by, hub or notification ID" }}
        selects={[{ key: "status", allLabel: "All statuses", chipLabel: "Status", options: BAG_STATUS_OPTIONS }]}
        dateRange={{ fromKey: "fromDate", toKey: "toDate", label: "Created" }}
      />
      <div>
        <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px]">
          {loading ? (
            <Loader />
          ) : (
            <>
              <MasterTable
                loading={loading}
                headers={customerHeader}
                data={customerData}
                handleAction={handleCustomer}
                filterFields={["companyName"]}
                entityType="Bag"
                headerToKeyMap={customerHeaderToKeyMap}
                handleAuth={handleAuthorization}
                noData={noData}
                pageDetails={pageDetails}
                currentPage={currentPage}
                pageSize={pageSize}
                totalRecord={totalRecord}
                fetchNextData={(page, size) =>
                  fetchBagData(page, filterData, size)
                }
                setCurrentPage={setCurrentPage}
                setPageSize={setPageSize}
                openModalFilter={openModalFilter}
                handleReset={handleReset}
                filterData={filterData}
                fetchData={() => fetchBagData(1, defaultFilterData)}
                handleItemsIncludedClick={handleItemsIncludedClick}
                hideFilterControls
              />
            </>
          )}

          {isModalOpenCreate ? (
            <AddCourierBagModal
              show={isModalOpenCreate}
              handleClose={closeModalCreate}
              editData={editData}
              action={modalAction}
              callApi={fetchBagData}
              columnData={columnData}
            />
          ) : null}

          {isAddItemModalOpen ? (
            <AddItemBagModal
              show={isAddItemModalOpen}
              handleClose={closeAddItemModal}
              editData={editData}
              action={modalAction}
              callApi={fetchOrderData}
              callTableApi={fetchBagData}
              columnData={columnData}
              headers={orderHeader}
              data={orderData}
              totalRecords={pageDetailsModal?.totalRecords || 0}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              loading={loadingModal}
              autoSelectAll={autoSelectAll}
            />
          ) : null}

          {isModalOpenFilter ? (
            <BagBookingFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setCustomerData={setCustomerData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              currentPage={currentPage}
              pageSize={pageSize}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
              defaultFilterData={defaultFilterData}
              handleItemsIncludedClick={handleItemsIncludedClick}
            />
          ) : null}

          {notificationModal && (
            <NotificationDetailsModal
              show={notificationModal}
              handleClose={() => setNotificationModal(false)}
              columnData={columnData}
            />
          )}

          {openToNotifyModal && (
            <SelectToNotifyModal
              show={openToNotifyModal}
              handleClose={() => setOpenToNotifyModal(false)}
              columnData={columnData}
              franchiseData={franchiseData}
              callApi={() => fetchBagData(currentPage)}
            />
          )}

          {openSuccessModal && (
            <SuccessModal
              show={openSuccessModal}
              handleClose={() => setOpenSuccessModal(false)}
              successMessage="Bag has been successfully unpacked."
            />
          )}
        </div>
      </div>
    </>
  );
};

export default BookingMaster;
